export enum AttendantTaskActionType {
  Start = 'Start',
  Pause = 'Pause',
  Skip = 'Skip',
  Resume = 'Resume',
  Cancel = 'Cancel',
  Complete = 'Complete'
}



// WEBPACK FOOTER //
// ./src/components/Attendant/shared/enum/attendantTaskActionType.ts